<template>
  <formulaire-view
    :steps="steps"
    :step="step"
    url="/prise-rendez-vous/"
    paramsName="propositions_dates"
    :endpoint="endpoint"
    :getRefs="$refs"
    :drawerWidth="280"
  >
    <template v-slot:step="{ sas, path, setState, code }">
      <component
        :is="path"
        :sas="sas"
        @validation-changed="setState(path, $event)"
        :ref="path"
        :endpoint="endpoint"
      >
        <ressource :code="code" />
      </component>
    </template>
  </formulaire-view>
</template>

<script>
import { mapGetters } from "vuex"
import FormulaireView from "@/views/FormulaireView.vue"

import Rencontres from "@/components/Formulaires/PriseRendezvous/Rencontres"
import LieuxInspection from "@/components/Formulaires/PriseRendezvous/LieuxInspection"

export default {
  props: {
    step: String
  },
  data() {
    return {
      endpoint: "prise-rendez-vous",
      allSteps: [
        { path: "introduction", code: "titre-introduction", state: "" },
        { path: "lieux-inspection", code: "titre-etape-1", state: "" },
        { path: "rencontres", code: "titre-etape-2", state: "" },
        { path: "soumission", code: "titre-soumission" }
      ]
    }
  },
  computed: {
    ...mapGetters(["sas"]),
    aucunLieuDInspection() {
      return this.sas?.sasPriseRendezvousInspection?.aucunLieuDInspection === true
    },
    steps() {
      return this.allSteps.filter(s => !(s.path === "rencontres" && this.aucunLieuDInspection))
    }
  },

  components: {
    FormulaireView,
    Rencontres,
    LieuxInspection
  }
}
</script>
